"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckPageUrl = void 0;
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var useCheckPageUrl = function (page) {
    var pathname = (0, navigation_1.usePathname)();
    return (0, react_1.useMemo)(function () {
        var regex = new RegExp("^\\/[a-z]{2}(?:-[A-Z]{2})?\\/".concat(page, "\\/"));
        return regex.test(pathname);
    }, [page, pathname]);
};
exports.useCheckPageUrl = useCheckPageUrl;
